module.exports = __webpack_public_path__ + "static/media/freeform-tool.4c51dd29.gif";